import { ReceiptLanguage } from "../../receipt-printer/enums";
import { ReceiptLanguages } from "../../receipt-printer/enums";
import { ConnectionType } from "../types";
import { PrintApiConnectionType, PrintApiLanguage } from "./types";

export function mapPrintApiConnectionType(
  apiConnectionType: PrintApiConnectionType
): ConnectionType {
  const connectionTypeMap: Record<PrintApiConnectionType, ConnectionType> = {
    [PrintApiConnectionType.usb]: ConnectionType.usb,
    [PrintApiConnectionType.bluetooth]: ConnectionType.bluetooth,
    [PrintApiConnectionType.lan]: ConnectionType.lan,
    [PrintApiConnectionType.wifi]: ConnectionType.lan,
    [PrintApiConnectionType.unknown]: ConnectionType.other,
  };

  return (
    connectionTypeMap[apiConnectionType] || ConnectionType.other
  );
}

export function mapConnectionTypeToPrintApi(connectionType: ConnectionType): PrintApiConnectionType {
  const map: Partial<Record<ConnectionType, PrintApiConnectionType>> = {
    [ConnectionType.usb]: PrintApiConnectionType.usb,
    [ConnectionType.bluetooth]: PrintApiConnectionType.bluetooth,
    [ConnectionType.lan]: PrintApiConnectionType.lan,
  };
  return map[connectionType] ?? PrintApiConnectionType.unknown;
}

export function mapLanguageToPrintApi(language: ReceiptLanguage): PrintApiLanguage {
  const map: Record<ReceiptLanguage, PrintApiLanguage> = {
    [ReceiptLanguages.esc]: PrintApiLanguage.epson,
    [ReceiptLanguages.starGraphic]: PrintApiLanguage.starGraphic,
    [ReceiptLanguages.starLine]: PrintApiLanguage.starLine,
    [ReceiptLanguages.starPrint]: PrintApiLanguage.starPRNT,
  };
  return map[language] ?? PrintApiLanguage.epson;
}

export function mapPrintApiLanguage(apiLanguage: string): ReceiptLanguage {
  const languageMap: Record<string, ReceiptLanguage> = {
    epson: ReceiptLanguages.esc,
    stargraphic: ReceiptLanguages.starGraphic,
    starline: ReceiptLanguages.starLine,
    starprnt: ReceiptLanguages.starPrint,
  };

  return languageMap[apiLanguage?.toLowerCase()] || ReceiptLanguages.esc;
}
